import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import {
  ChargesResponseClaimDTO,
} from 'dtos';
import Tag from 'core/components/Tag';
import ToolTip from 'core/components/Tooltip';

type Props = {
  hasSecondary?: boolean;
  isSecondary?: boolean;
  claimIndex?: number;
  className?: string;
  children?: ReactNode;
  tooltip?: ReactNode | string;
};

type ClaimTagByTypeProps = {
  isSecondary?: boolean;
  hasSecondary?: boolean;
  className?: string;
};

export function ClaimTagByType({
  isSecondary = false,
  hasSecondary = false,
  className,
}: ClaimTagByTypeProps) {
  return (
    <div className={clsx(
      'text-white text-[9px] p-1 rounded font-semibold w-4 h-4 flex items-center justify-center',
      { 'bg-emerald-600': hasSecondary },
      { 'bg-sky-700': isSecondary },
      className,
    )}
    >
      {hasSecondary && 'P'}
      {isSecondary && 'S'}
    </div>
  );
}
export default function ClaimTag({
  claimIndex,
  status,
  className,
  hasSecondary = false,
  isSecondary = false,
  children,
  tooltip,
  hasSecondaryClaim = false,
}: ChargesResponseClaimDTO & Props) {
  return !isNil(status)
    ? (
      <Tag
        className={clsx(
          'claim-status-tag',
          '!w-fit relative flex items-center gap-1 !h-6',
          className,
          { 'bg-sky-200 border-sky-800': isSecondary },
        )}
        tagName={status}
        defaultColor="border !bg-brown-100 !text-brown-600 !border-brown-300"
        tooltip={tooltip}
      >
        {isNil(children) ? (
          <>
            {(hasSecondary || hasSecondaryClaim) && (
              <ToolTip title="Primary Claim">
                <div className="claim-status-indicator">
                  <ClaimTagByType hasSecondary />
                </div>
              </ToolTip>
            )}
            {isSecondary && (
              <ToolTip title="Secondary Claim">
                <div className="claim-status-indicator">
                  <ClaimTagByType isSecondary />
                </div>
              </ToolTip>
            )}
            <span className="font-semibold text-inherit">
              {/out-of-pocket/i.test(status ?? '') || isNil(claimIndex)
                ? status
                : `Claim ${claimIndex + 1}: ${status}`}
            </span>
          </>
        ) : children}
      </Tag>
    ) : null;
}
